import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    GET_SWING_VIDEO_USER_SAS
} from "../constants/ActionTypes";
import {
    getSwingVideoUserSasSuccess,
    getSwingVideoUserSasError
} from "../actions/MediaAction";
import { getSwingVideoUserSasApi } from "../api/MediaApi";

function* getSwingVideoUserSasRequest({ payload }) {
    try {
        const swingVideoUserSas = yield call(getSwingVideoUserSasApi, payload);
        if (swingVideoUserSas.code) {
            yield put(getSwingVideoUserSasError(swingVideoUserSas));
        } else {
            yield put(getSwingVideoUserSasSuccess(swingVideoUserSas));
        }
    } catch (error) {
        yield put(getSwingVideoUserSasError(error));
    }
}

export function* getSwingVideoUserSas() {
    yield takeEvery(GET_SWING_VIDEO_USER_SAS, getSwingVideoUserSasRequest);
}

export default function* rootSaga() {
    yield all([fork(getSwingVideoUserSas)
    ]);
}